import React from 'react'
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import python from "../assets/python.png";
import haskell from "../assets/haskell.png";
import node from "../assets/node.png";
import react from "../assets/react.png";
import tailwind from "../assets/tailwind.png";

const Experience = () => {

    const techs = [
        {
            id: 1,
            src: python,
            title: "Python",
            style: 'shadow-amber-500'
        },
        {
            id: 2,
            src: haskell,
            title: "Haskell",
            style: 'shadow-purple-500'
        },
        {
            id: 3,
            src: html,
            title: "HTML",
            style: 'shadow-orange-500'
        },
        {
            id: 4,
            src: css,
            title: "CSS",
            style: 'shadow-blue-500'
        },
        {
            id: 5,
            src: javascript,
            title: "JavaScript",
            style: 'shadow-yellow-500'
        },
        {
            id: 6,
            src: react,
            title: "React",
            style: 'shadow-cyan-600'
        },
        {
            id: 7,
            src: tailwind,
            title: "Tailwind",
            style: 'shadow-sky-400'
        },
        {
            id: 8,
            src: node,
            title: "Node",
            style: 'shadow-lime-500'
        },
    ]

  return (
    <div name='experience' className='bg-gradient-to-br from-green-900 via-black to-blue-900 w-full h-screen'>
        <div className=' max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
            <div>
                <p className='text-4xl font-bold inline text-transparent bg-clip-text bg-gradient-to-r  from-cyan-400 to-blue-500 border-b-4 border-blue-500'>
                    Code
                </p>
                <p className=' py-6'>
                    The technologies and languages I've worked with
                </p>
            </div>
            <div className=' w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>

                {
                    techs.map(({id, src, title, style}) => (
                        <div key={id} className={`shadow-md ${style} hover:scale-105 duration-500 py-2 rounded-lg`}>
                            <img src={src} alt="" className=' w-20 mx-auto'/>
                            <p className='mt-4'>{title}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    </div>
  )
}

export default Experience